import React from 'react';
import BarChartComponent from "../commons/BarChartComponent";


function MultipleChoiceChartComponent(props) {
    return (
        <React.Fragment>
            <BarChartComponent
                isMobile={props.isMobile}
                chartIndex={props.chartIndex}
                updateChartInfo={props.updateChartInfo}
                chartConfig={props.configuration}
                answersData={props.questionAnswers}
                sortingOptions={props.sortingOptions}
                questionId={props.questionData.question.question_id}
                questionTitle={props.questionData.question.id + ". " + props.questionData.question.question}
                questionChoices={props.questionData.question.choices}
            />
        </React.Fragment>
    )
}

export default MultipleChoiceChartComponent;